import React, { Component } from 'react';
import { 
    Dialog, 
    DialogTitle, 
    DialogContent, 
    DialogActions, 
    Button,
    Box,
    Typography,
    Divider,
    IconButton,
    Slide,
    Paper,
    TextField,
    InputAdornment
} from '@mui/material';
import { Close, MonitorWeight, Info } from '@mui/icons-material';

import AdminAPI from '../service/AdminAPI';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

class UpdateTotalWeight extends Component {
    constructor(props) {
        super(props);

        this.state = {
            show: false,
            weight: ''
        }
    }

    handleShow = (title) => this.setState({ show: true, title });

    handleClose = () => {
        this.setState({ show: false, weight: '' });
        this.props.onClose();
    }

    handleSubmit = (ev) => {
        ev.preventDefault();
        
        AdminAPI.ChangeTotalWeight(parseInt(this.state.weight))
            .then(() => window.location.reload())
            .catch(console.error);
    }

    componentDidUpdate() {
        if (this.state.show !== this.props.show) {
            this.setState({ show: this.props.show, weight: this.props.maxWeight || '' });
        }
    }

    render() {
        return (
            <Dialog
                open={this.state.show}
                onClose={this.handleClose}
                TransitionComponent={Transition}
                maxWidth="sm"
                fullWidth
                PaperProps={{
                    sx: {
                        borderRadius: { xs: '12px', sm: '20px' },
                        position: 'relative',
                        margin: { xs: '16px', sm: '32px' },
                        maxHeight: { xs: 'calc(100vh - 32px)', sm: '90vh' }
                    }
                }}
            >
                {/* Close Button */}
                <IconButton
                    onClick={this.handleClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: '#666',
                        zIndex: 1
                    }}
                >
                    <Close />
                </IconButton>

                {/* Header with gradient */}
                <Box
                    sx={{
                        background: 'linear-gradient(135deg, #2e7d32 0%, #66bb6a 100%)',
                        pt: { xs: 3, sm: 4 },
                        pb: { xs: 2.5, sm: 3 },
                        px: { xs: 2, sm: 3 },
                        color: 'white'
                    }}
                >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 1.5, sm: 2 } }}>
                        <MonitorWeight sx={{ fontSize: { xs: '1.8rem', sm: '2.5rem' } }} />
                        <DialogTitle sx={{ p: 0 }}>
                            <Typography variant="h4" sx={{ fontWeight: 700, color: 'white', fontSize: { xs: '1.5rem', sm: '2rem' } }}>
                                Gesamtgewicht
                            </Typography>
                            <Typography variant="body2" sx={{ opacity: 0.9, mt: 0.5, fontSize: { xs: '0.8rem', sm: '0.875rem' } }}>
                                Maximales Gewicht festlegen
                            </Typography>
                        </DialogTitle>
                    </Box>
                </Box>

                <DialogContent sx={{ pt: { xs: 2.5, sm: 4 }, pb: { xs: 2, sm: 3 }, px: { xs: 2, sm: 3 } }}>
                    <form onSubmit={this.handleSubmit} id="weight-form">
                        {/* Info Box */}
                        <Paper
                            elevation={0}
                            sx={{
                                bgcolor: '#fff3e0',
                                borderRadius: '12px',
                                p: 2,
                                mb: 3,
                                border: '2px solid #ffe0b2',
                                display: 'flex',
                                gap: 1.5,
                                alignItems: 'flex-start'
                            }}
                        >
                            <Info sx={{ color: '#f57c00', mt: 0.5 }} />
                            <Box>
                                <Typography variant="subtitle2" sx={{ fontWeight: 600, color: '#e65100', mb: 0.5 }}>
                                    Hinweis
                                </Typography>
                                <Typography variant="body2" sx={{ color: '#666' }}>
                                    Aktuelles Gesamtgewicht: <strong>{this.props.maxWeight} Kg/L</strong>
                                </Typography>
                            </Box>
                        </Paper>

                        {/* Weight Input */}
                        <Paper
                            elevation={0}
                            sx={{
                                bgcolor: '#e8f5e9',
                                borderRadius: '12px',
                                p: 2.5,
                                border: '2px solid #c8e6c9'
                            }}
                        >
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                                <MonitorWeight sx={{ color: '#2e7d32' }} />
                                <Typography variant="subtitle2" sx={{ fontWeight: 600, color: '#1b5e20' }}>
                                    Neues Gesamtgewicht
                                </Typography>
                            </Box>
                            <TextField
                                name="weight"
                                type="number"
                                value={this.state.weight}
                                onChange={(e) => this.setState({ weight: e.target.value })}
                                placeholder="Gewicht eingeben"
                                fullWidth
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <Typography variant="body2" sx={{ fontWeight: 600, color: '#2e7d32' }}>
                                                Kg/L
                                            </Typography>
                                        </InputAdornment>
                                    ),
                                    inputProps: { 
                                        min: 0,
                                        step: 1,
                                        style: { 
                                            fontSize: '1.5rem', 
                                            fontWeight: 600,
                                            textAlign: 'center'
                                        }
                                    }
                                }}
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        bgcolor: 'white',
                                        borderRadius: '10px',
                                        '&:hover fieldset': {
                                            borderColor: '#2e7d32',
                                        },
                                        '&.Mui-focused fieldset': {
                                            borderColor: '#2e7d32',
                                        },
                                    }
                                }}
                            />
                        </Paper>
                    </form>
                </DialogContent>

                <Divider />

                <DialogActions sx={{ 
                    p: { xs: 2, sm: 3 }, 
                    gap: { xs: 1.5, sm: 2 },
                    flexDirection: { xs: 'column', sm: 'row' }
                }}>
                    <Button
                        onClick={this.handleClose}
                        variant="outlined"
                        size="large"
                        fullWidth
                        sx={{
                            borderRadius: '10px',
                            textTransform: 'none',
                            fontWeight: 600,
                            borderColor: '#ddd',
                            color: '#666',
                            fontSize: { xs: '0.9rem', sm: '1rem' },
                            py: { xs: 1.2, sm: 1.5 },
                            order: { xs: 2, sm: 1 },
                            '&:hover': {
                                borderColor: '#bbb',
                                bgcolor: '#f5f5f5'
                            }
                        }}
                    >
                        Abbrechen
                    </Button>
                    <Button
                        type="submit"
                        form="weight-form"
                        variant="contained"
                        size="large"
                        fullWidth
                        startIcon={<MonitorWeight />}
                        sx={{
                            bgcolor: '#2e7d32',
                            color: 'white',
                            fontWeight: 600,
                            textTransform: 'none',
                            fontSize: { xs: '0.9rem', sm: '1.1rem' },
                            py: { xs: 1.2, sm: 1.5 },
                            borderRadius: '10px',
                            boxShadow: '0 4px 12px rgba(46, 125, 50, 0.3)',
                            order: { xs: 1, sm: 2 },
                            '&:hover': {
                                bgcolor: '#1b5e20',
                                boxShadow: '0 6px 16px rgba(46, 125, 50, 0.4)',
                                transform: 'translateY(-2px)'
                            },
                            transition: 'all 0.2s ease'
                        }}
                    >
                        Gesamtgewicht aktualisieren
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

export default UpdateTotalWeight;